<template>
<div>
    <md-dialog :md-active.sync="showDialog" class="pricing-filter" :md-click-outside-to-close="clickOutside">
        <md-dialog-title>Add Filters</md-dialog-title>

        <div class="layout-dialog">
            <!-- <multiselect v-model="selectedFilterType" id="type" :class="(classZindex == 'type') ? 'z-index-top' : ''" label="label" track-by="id" placeholder="Search Type" :open-direction="'bottom'" :options="filtersType" :searchable="true" :loading="isLoadingType" :internal-search="false" :max-height="170" :show-no-results="false" :custom-label="customLabel" :select-label="''" :deselect-label="''" :selected-label="''" :hide-selected="true" @select="setDataFilter" @open="onOpenTreeview"></multiselect>
            <multiselect v-model="selectedFilterGroup" id="group" :class="(classZindex == 'group') ? 'z-index-top' : ''" label="label" track-by="id" placeholder="Search Group" :open-direction="'bottom'" :options="filtersGroup" :searchable="true" :loading="isLoadingGroup" :internal-search="false" :max-height="130" :show-no-results="false" :custom-label="customLabel" :select-label="''" :deselect-label="''" :selected-label="''" :hide-selected="true" @select="setDataFilter" @open="onOpenTreeview"></multiselect>
            <multiselect v-model="selectedFilterSubGroup" id="sub_group" :class="(classZindex == 'sub_group') ? 'z-index-top' : ''" label="label" track-by="id" placeholder="Search Sub Group" :open-direction="'top'" :options="filtersSubGroup" :searchable="true" :loading="isLoadingSubGroup" :internal-search="false" :max-height="160" :show-no-results="false" :custom-label="customLabel" :select-label="''" :deselect-label="''" :selected-label="''" :hide-selected="true" @select="setDataFilter" @open="onOpenTreeview"></multiselect>
            <multiselect v-model="selectedFilterCg" id="cg" label="label" :class="(classZindex == 'label') ? 'z-index-top' : ''" track-by="id" placeholder="Search CG" :open-direction="'top'" :options="filtersCg" :searchable="true" :loading="isLoadingCg" :internal-search="false" :max-height="220" :show-no-results="false" :custom-label="customLabel" :select-label="''" :deselect-label="''" :selected-label="''" :hide-selected="true" @select="setDataFilter" @open="onOpenTreeview"></multiselect> -->

            <multiselect v-model="selectedFilterType" id="type" :class="(classZindex == 'type') ? 'z-index-top' : ''" label="label" track-by="id" placeholder="Search Type" :open-direction="'bottom'" :options="filtersType" :searchable="true" :loading="isLoadingType" :max-height="170" :show-no-results="false" :custom-label="customLabel" :select-label="''" :deselect-label="''" :selected-label="''" :hide-selected="true" @select="setDataFilter">
                <template slot="singleLabel" slot-scope="{ option }">
                    <div>
                        <div class="-label">
                            {{ option.id }} - {{ option.label }}
                        </div>
                        <div class="-delete" @mousedown.prevent.stop="clearAll(option.id, 'type')"><i class="material-icons">close</i></div>
                    </div>
                </template>
            </multiselect>
            <multiselect v-model="selectedFilterGroup" id="group" :class="(classZindex == 'group') ? 'z-index-top' : ''" label="label" track-by="id" placeholder="Search Group" :open-direction="'bottom'" :options="filtersGroup" :searchable="true" :loading="isLoadingGroup" :max-height="130" :show-no-results="false" :custom-label="customLabel" :select-label="''" :deselect-label="''" :selected-label="''" :hide-selected="true" @select="setDataFilter">
                <template slot="singleLabel" slot-scope="{ option }">
                    <div>
                        <div class="-label">
                            {{ option.id }} - {{ option.label }}
                        </div>
                        <div class="-delete" @mousedown.prevent.stop="clearAll(option.id, 'group')"><i class="material-icons">close</i></div>
                    </div>
                </template>
            </multiselect>
            <multiselect v-model="selectedFilterSubGroup" id="sub_group" :class="(classZindex == 'sub_group') ? 'z-index-top' : ''" label="label" track-by="id" placeholder="Search Sub Group" :open-direction="'top'" :options="filtersSubGroup" :searchable="true" :loading="isLoadingSubGroup" :max-height="160" :show-no-results="false" :custom-label="customLabel" :select-label="''" :deselect-label="''" :selected-label="''" :hide-selected="true" @select="setDataFilter">
                <template slot="singleLabel" slot-scope="{ option }">
                    <div>
                        <div class="-label">
                            {{ option.id }} - {{ option.label }}
                        </div>
                        <div class="-delete" @mousedown.prevent.stop="clearAll(option.id, 'sub_group')"><i class="material-icons">close</i></div>
                    </div>
                </template>
            </multiselect>
            <multiselect v-model="selectedFilterCg" id="cg" label="label" :class="(classZindex == 'label') ? 'z-index-top' : ''" track-by="id" placeholder="Search CG" :open-direction="'top'" :options="filtersCg" :searchable="true" :loading="isLoadingCg" :max-height="220" :show-no-results="false" :custom-label="customLabel" :select-label="''" :deselect-label="''" :selected-label="''" :hide-selected="true" @select="setDataFilter">
                <template slot="singleLabel" slot-scope="{ option }">
                    <div>
                        <div class="-label">
                            {{ option.id }} - {{ option.label }}
                        </div>
                        <div class="-delete" @mousedown.prevent.stop="clearAll(option.id, 'cg')"><i class="material-icons">close</i></div>
                    </div>
                </template>
            </multiselect>

            <!-- <div class="md-layout filter-items">
                <input v-model="vType" placeholder="Search Type">
                <input v-model="vGroup" placeholder="Search Group">
                <input v-model="vSubGroup" placeholder="Search Sup Group">
                <input v-model="vCG" placeholder="Search CG">
            </div> -->
        </div>

        <md-dialog-actions class="-action">
            <md-button class="md-primary -cancel" @click="onClickCancel()">CANCEL</md-button>
            <md-button class="md-primary -filter" @click="onClickFilter()">ADD FILTER</md-button>
        </md-dialog-actions>
    </md-dialog>
</div>
</template>

<script>
import PricingService from "@/services/pricing";

export default {
    name: "pricingdialogfilter",
    props: ["valueTab", "vSearch", "vFilter", "typeAll"],
    components: {},
    watch: {},
    data() {
        return {
            showDialog: true,
            clickOutside: false,
            selectedFilterType: [],
            selectedFilterGroup: [],
            selectedFilterSubGroup: [],
            selectedFilterCg: [],
            filters: [],
            filtersType: [],
            filtersGroup: [],
            filtersSubGroup: [],
            filtersCg: [],
            isLoadingType: false,
            isLoadingGroup: false,
            isLoadingSubGroup: false,
            isLoadingCg: false,
            classZindex: '',
            setArrFilter: [],
            valQueryType: '',
            valQueryGroup: '',
            valQuerySubGroup: '',
            valQueryCg: '',
            arrFilter: [],
            arrType: {},
            arrGroup: {},
            arrSubGroup: {},
            arrCg: {},
            // value: null,
            // options: [
            //     { name: 'Vue.js', language: 'JavaScript' },
            //     { name: 'Rails', language: 'Ruby' },
            //     { name: 'Sinatra', language: 'Ruby' },
            //     { name: 'Laravel', language: 'PHP', $isDisabled: true },
            //     { name: 'Phoenix', language: 'Elixir' }
            // ]
        };
    },
    mounted() {

        this.filtersType = this.typeAll;

        if (this.vFilter.type && !Array.isArray(this.vFilter.type)) {
            this.asyncFind(this.vFilter.type.id, 'type', 'type');
        }
        if (this.vFilter.group && !Array.isArray(this.vFilter.group)) {
            this.asyncFind(this.vFilter.group.id, 'group', 'group');
        }
        if (this.vFilter.subGroup && !Array.isArray(this.vFilter.subGroup)) {
            this.asyncFind(this.vFilter.subGroup.id, 'sub_group', 'sub_group');
        }
        if (this.vFilter.cg && !Array.isArray(this.vFilter.cg)) {
            this.asyncFind(this.vFilter.cg.id, 'cg', 'cg');
        }
    },
    computed: {},
    methods: {
        // limitText (count) {
        //     return `and ${count} other filters`
        // },
        asyncFind(query, id, setdata) {
            let self = this;
            this.checkLoadData = false;

            // if (query.length > 1) {
            //     this.classZindex = id;

            //     let statusType = "0";
            //     let statusGroup = "0";
            //     let statusSubGroup = "0";
            //     let statusCg = "0";

            //     if (id == 'type') {
            //         self.isLoadingType = true;
            //         statusType = "1";
            //         this.valQueryType = query;
            //     }
            //     if (id == 'group') {
            //         self.isLoadingGroup = true;
            //         statusGroup = "1";
            //         this.valQueryGroup = query;
            //     }
            //     if (id == 'sub_group') {
            //         self.isLoadingSubGroup = true;
            //         statusSubGroup = "1";
            //         this.valQuerySubGroup = query;
            //     }
            //     if (id == 'cg') {
            //         self.isLoadingCg = true;
            //         statusCg = "1";
            //         this.valQueryCg = query;
            //     }

            //     this.arrType = {
            //         status: statusType,
            //         value: this.valQueryType
            //     }
            //     this.arrGroup = {
            //         status: statusGroup,
            //         value: this.valQueryGroup
            //     }
            //     this.arrSubGroup = {
            //         status: statusSubGroup,
            //         value: this.valQuerySubGroup
            //     }
            //     this.arrCg = {
            //         status: statusCg,
            //         value: this.valQueryCg
            //     }

            //     this.arrFilter = {
            //         keyword: this.vSearch.keyword,
            //         type: this.arrType,
            //         group: this.arrGroup,
            //         subGroup: this.arrSubGroup,
            //         cg: this.arrCg
            //     };

            //     PricingService.FilterProducts(this.arrFilter)
            //         .then(response => {
            //             if (id == 'type') {
            //                 self.filtersType = response;
            //                 self.isLoadingType = false;
            //             }
            //             if (id == 'group') {
            //                 self.filtersGroup = response;
            //                 self.isLoadingGroup = false;
            //             }
            //             if (id == 'sub_group') {
            //                 self.filtersSubGroup = response;
            //                 self.isLoadingSubGroup = false;
            //             }
            //             if (id == 'cg') {
            //                 self.filtersCg = response;
            //                 self.isLoadingCg = false;
            //             }
            //         }).catch();
            // }

            if (setdata) {
                if (setdata == 'type') {
                    this.selectedFilterType = this.vFilter.type;
                }
                if (setdata == 'group') {
                    this.selectedFilterGroup = this.vFilter.group;
                }
                if (setdata == 'sub_group') {
                    this.selectedFilterSubGroup = this.vFilter.subGroup;
                }
                if (setdata == 'cg') {
                    this.selectedFilterCg = this.vFilter.cg;
                }

                this.setArrFilter = {
                    keyword: this.vSearch.keyword,
                    type: this.selectedFilterType,
                    group: this.selectedFilterGroup,
                    subGroup: this.selectedFilterSubGroup,
                    cg: this.selectedFilterCg,
                };
            }

            let val = { id: query };
            this.setDataFilter(val, setdata);
        },
        clearAll(id, type) {
            if (type == 'type') {
                this.selectedFilterType = [];
                this.valQueryType = "";

                this.selectedFilterGroup = [];
                this.selectedFilterSubGroup = [];
                this.selectedFilterCg = [];

                this.filtersGroup = [];
                this.filtersSubGroup = [];
                this.filtersCg = [];

                this.valQueryGroup = "";
                this.valQuerySubGroup = "";
                this.valQueryCg = "";

            } else if (type == 'group') {
                this.selectedFilterGroup = [];
                this.valQueryGroup = "";

                this.selectedFilterSubGroup = [];
                this.selectedFilterCg = [];

                this.filtersSubGroup = [];
                this.filtersCg = [];

                this.valQuerySubGroup = "";
                this.valQueryCg = "";

            } else if (type == 'sub_group') {
                this.selectedFilterSubGroup = [];
                this.valQuerySubGroup = "";

                this.selectedFilterCg = [];
                this.filtersCg = [];

                this.valQueryCg = "";
                
            } else if (type == 'cg') {
                this.selectedFilterCg = [];
                this.valQueryCg = "";
            }
        },
        customLabel({
            id,
            label
        }) {
            return `${id} - ${label}`
        },
        setDataFilter(selectedOption, id) {
            let self = this;

            let statusType = "0";
            let statusGroup = "0";
            let statusSubGroup = "0";
            let statusCg = "0";
            let query = selectedOption.id;

            if (id == 'type') {
                self.isLoadingType = true;
                statusType = "1";
                this.valQueryType = query;
            }
            if (id == 'group') {
                self.isLoadingGroup = true;
                statusGroup = "1";
                this.valQueryGroup = query;
            }
            if (id == 'sub_group') {
                self.isLoadingSubGroup = true;
                statusSubGroup = "1";
                this.valQuerySubGroup = query;
            }
            if (id == 'cg') {
                self.isLoadingCg = true;
                statusCg = "1";
                this.valQueryCg = query;
            }

            this.arrType = {
                status: statusType,
                value: this.valQueryType
            }
            this.arrGroup = {
                status: statusGroup,
                value: this.valQueryGroup
            }
            this.arrSubGroup = {
                status: statusSubGroup,
                value: this.valQuerySubGroup
            }
            this.arrCg = {
                status: statusCg,
                value: this.valQueryCg
            }
            this.arrFilter = {
                    keyword: this.vSearch.keyword,
                    type: this.arrType,
                    group: this.arrGroup,
                    subGroup: this.arrSubGroup,
                    cg: this.arrCg
                };

                PricingService.FilterProducts(this.arrFilter)
                    .then(response => {
                        if (id == 'type') {
                            self.filtersGroup = response;
                            self.isLoadingType = false;
                        }
                        if (id == 'group') {
                            self.filtersSubGroup = response;
                            self.isLoadingGroup = false;
                        }
                        if (id == 'sub_group') {
                            self.filtersCg = response;
                            self.isLoadingSubGroup = false;
                        }
                        // if (id == 'cg') {
                        //     self.filtersCg = response;
                            self.isLoadingCg = false;
                        // }
                    }).catch();

            /*
            if (id == 'type') {
                this.selectedFilterType = selectedOption;
                this.valQueryType = selectedOption.id;
            }
            if (id == 'group') {
                this.selectedFilterGroup = selectedOption;
                this.valQueryGroup = selectedOption.id;
            }
            if (id == 'sub_group') {
                this.selectedFilterSubGroup = selectedOption;
                this.valQuerySubGroup = selectedOption.id;
            }
            if (id == 'cg') {
                this.selectedFilterCg = selectedOption;
                this.valQueryCg = selectedOption.id;
            }

            this.setArrFilter = {
                keyword: this.vSearch.keyword,
                type: this.selectedFilterType,
                group: this.selectedFilterGroup,
                subGroup: this.selectedFilterSubGroup,
                cg: this.selectedFilterCg,
            };

            PricingService.GetFilterProducts(this.setArrFilter)
                .then(response => {
                    // console.log("response ==>", response);
                    if (response.type !== undefined && response.type.length === undefined && response.type.id !== undefined) {
                        self.selectedFilterType = response.type;
                        this.valQueryType = response.type.id;
                        this.arrType = {
                            status: "0",
                            value: this.valQueryType
                        }
                    }
                    if (response.group !== undefined && response.group.length === undefined && response.group.id !== undefined) {
                        self.selectedFilterGroup = response.group;
                        this.valQueryGroup = response.group.id;
                        this.arrGroup = {
                            status: "0",
                            value: this.valQueryGroup
                        }
                    }
                    if (response.sub_group !== undefined && response.sub_group.length === undefined && response.sub_group.id !== undefined) {
                        self.selectedFilterSubGroup = response.sub_group;
                        this.valQuerySubGroup = response.sub_group.id;
                        this.arrSubGroup = {
                            status: "0",
                            value: this.valQuerySubGroup
                        }
                    }
                    if (response.cg !== undefined && response.cg.length === undefined && response.cg.id !== undefined) {
                        self.selectedFilterCg = response.cg;
                        this.valQueryCg = response.cg.id;
                        this.arrCg = {
                            status: "0",
                            value: this.valQueryCg
                        }
                    }
                }).catch();
            */
        },
        onOpenTreeview(id) {
            if (id == "type") {
                this.selectedFilterType = [];
            } else if (id == "group") {
                this.selectedFilterGroup = [];
            } else if (id == "sub_group") {
                this.selectedFilterSubGroup = [];
            } else {
                this.selectedFilterCg = [];
            }
        },
        onClickFilter() {
            let dataSearch = {
                keyword: this.vSearch.keyword,
                type: (this.selectedFilterType) ? this.selectedFilterType.id : "",
                group: (this.selectedFilterGroup) ? this.selectedFilterGroup.id : "",
                subGroup: (this.selectedFilterSubGroup) ? this.selectedFilterSubGroup.id : "",
                cg: (this.selectedFilterCg) ? this.selectedFilterCg.id : "",
                // type: this.vType,
                // group: this.vGroup,
                // subGroup: this.vSubGroup,
                // cg: this.vCG,
                start: 0,
                limit: 20
            };

            this.setArrFilter = {
                keyword: this.vSearch.keyword,
                type: (this.selectedFilterType == null) ? [] : this.selectedFilterType,
                group: (this.selectedFilterGroup == null) ? [] : this.selectedFilterGroup,
                subGroup: (this.selectedFilterSubGroup == null) ? [] : this.selectedFilterSubGroup,
                cg: (this.selectedFilterCg == null) ? [] : this.selectedFilterCg
            };

            this.$emit("clickFilter", dataSearch, this.setArrFilter);
            // this.$emit("clickFilter", dataSearch);
        },
        onClickCancel() {
            this.$emit("clickCancel", false);
        }
    },
    beforeDestroy() {}
};
</script>

<style lang="scss">
.pricing-filter {
    width: 35%;

    .md-dialog-title.md-title {
        font-size: 18px;
        margin-bottom: 5px;
        padding: 24px 30px 0;
    }

    .dialog-content {
        padding: 20px;
    }

    .layout-dialog {
        padding: 10px 25px 5px 25px;

        .filter-items {
            padding-left: 3px;

            input {
                width: 100%;
                margin: 7px;
                padding-left: 5px;
                padding-right: 5px;
                height: 36px;
                border: 1px solid #ddd;
                border-radius: 5px;
                background: #fff;
            }

            ::placeholder {
                color: #BDBDBD;
                opacity: 1;
            }
        }
    }

    .-action {
        padding: 8px 20px 10px 24px;
        bottom: 0px;
        margin-right: auto;
        margin-left: auto;
        width: 100%;
        justify-content: flex-end;

        .-cancel .md-button-content {
            color: #727272;
        }

        .-filter {
            color: #3f51b5;
        }
    }

    .multiselect {
        .z-index-top {
            z-index: 10;
        }

        // width: 95%;
        // margin: 5px;
        // padding: 5px;
        // padding: 5px 5px 5px 2px;
        margin: 12px 5px 12px 2px;

        // .multiselect__select {
        //     margin-top: 5px;
        // }

        .multiselect__single,
        .multiselect__input {
            font-size: 14px;

            div {
                display: flex;
                width: 100%;

                // .-label {
                //     width: 90%;
                // }
                .-delete {
                    width: 5%;

                    .material-icons {
                        font-size: 18px;
                        margin-top: 1px;
                        cursor: pointer;
                        color: gray;
                    }
                }
            }
        }

        .multiselect__tags {
            padding: 8px 30px 0 8px;

            ::placeholder {
                color: #BDBDBD;
                opacity: 1;
            }
        }

        .multiselect__content-wrapper {
            // width: 98%;
            font-size: 14px;
            z-index: 10;
        }

        .multiselect__option {
            min-height: 34px;
            padding: 12px 12px 0px 12px;
        }

        ::-webkit-scrollbar {
            width: 8px;
            height: 8px;
        }
    }
}
</style>
